import React, { lazy, Suspense } from "react";

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

// ─────────────────────────────────────────────────────────────────────────────
// PÁGINAS PÚBLICAS (carregam NA HORA / "eager")
// São as páginas pré-renderizadas que o Google e as IAs leem. Precisam carregar
// imediatamente para a "foto pronta" encaixar (hidratar) sem nenhum atraso.
// ─────────────────────────────────────────────────────────────────────────────
import Landpage from 'screens/Landpage'
import Landpage02 from 'screens/Landpage02'
import Conteudos from 'screens/Conteudos'
import Tv from 'screens/Tv'
import DashboardPrivacityPolice from "screens/PrivacityPolice";
import NotFound from 'screens/NotFound'

// ─────────────────────────────────────────────────────────────────────────────
// DEMAIS PÁGINAS (carregam SÓ QUANDO ACESSADAS / "lazy")
// Login, área do assinante e player de vídeo são as partes mais "pesadas".
// Com o lazy(), o código delas vira um pacote separado que só é baixado quando
// a pessoa realmente entra nessas telas — deixando a página inicial bem leve.
// ─────────────────────────────────────────────────────────────────────────────
const Login = lazy(() => import('screens/Authentication/Login'))
const Register = lazy(() => import('screens/Authentication/Register'))
const Forgot = lazy(() => import('screens/Authentication/Forgot'))
const CreatePassword = lazy(() => import('screens/Authentication/CreatePassword'))

const DashboardSelectProfile = lazy(() => import('screens/Dashboard/SelectProfile'))
const DashboardCreateProfile = lazy(() => import('screens/Dashboard/CreateProfile'))
const DashboardHome = lazy(() => import('screens/Dashboard/Home'))
const DashboardFavorites = lazy(() => import('screens/Dashboard/Favorites'))
const DashboardDownloads = lazy(() => import('screens/Dashboard/Downloads'))
const DashboardCategory = lazy(() => import('screens/Dashboard/Category'))
const DashboardSearch = lazy(() => import('screens/Dashboard/Search'))

const DashboardAbout = lazy(() => import('screens/Dashboard/About'))
const DashboardHelp = lazy(() => import('screens/Dashboard/Help'))
const DashboardSign = lazy(() => import('screens/Dashboard/Sign'))

const DashboardAccount = lazy(() => import('screens/Dashboard/Account'))
const DashboardAccountConfirmEmail = lazy(() => import('screens/Dashboard/Account/ConfirmEmail'))
const DashboardAccountChangeEmail = lazy(() => import('screens/Dashboard/Account/ChangeEmail'))
const DashboardAccountCreatePassword = lazy(() => import('screens/Dashboard/Account/CreatePassword'))
const DashboardAccountPlan = lazy(() => import('screens/Dashboard/Account/Plan'))
const DashboardAccountChangePlan = lazy(() => import('screens/Dashboard/Account/ChangePlan'))
const DashboardAccountCancelSubscription = lazy(() => import('screens/Dashboard/Account/CancelSubscription'))
const DashboardAccountChangeCreditCard = lazy(() => import('screens/Dashboard/Account/ChangeCreditCard'))

const DashboardPlayer = lazy(() => import('screens/Dashboard/Player'))

// Telinha de "Carregando..." mostrada por um instante enquanto o pacote da
// página acessada é baixado. Simples e leve de propósito.
const Carregando = () => (
  <div style={{
    minHeight: '60vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', color: '#652BC9',
    fontFamily: 'sans-serif', fontSize: 18
  }}>
    Carregando…
  </div>
);

export default function AppRouter() {
    return (
      <Router>
        <div>
          <Suspense fallback={<Carregando />}>
          <Switch>
            <Route path="/" exact> <Landpage /> </Route>
            <Route path="/planos" exact> <Landpage02 /> </Route>
            <Route path="/conteudos" exact> <Conteudos /> </Route>
            <Route path="/tv" exact> <Tv /> </Route>

            <Route path="/login" exact> <Login /> </Route>
            <Route path="/register" exact> <Register /> </Route>
            <Route path="/forgot" exact> <Forgot /> </Route>
            <Route path="/create-password" exact> <CreatePassword /> </Route>

            <Route path="/dashboard" exact> <DashboardHome /> </Route>
            <Route path="/dashboard/select-profile" exact> <DashboardSelectProfile /> </Route>
            <Route path="/dashboard/create-profile" exact> <DashboardCreateProfile /> </Route>
            <Route path="/dashboard/favorites" exact> <DashboardFavorites /> </Route>
            <Route path="/dashboard/downloads" exact> <DashboardDownloads /> </Route>
            <Route path="/dashboard/category/:slug" exact> <DashboardCategory /> </Route>
            <Route path="/dashboard/search" exact> <DashboardSearch /> </Route>

            <Route path="/dashboard/about" exact> <DashboardAbout /> </Route>
            <Route path="/dashboard/help" exact> <DashboardHelp /> </Route>
            <Route path="/dashboard/sign" exact> <DashboardSign /> </Route>

            <Route path="/dashboard/account" exact> <DashboardAccount /> </Route>
            <Route path="/dashboard/account/confirm-email" exact> <DashboardAccountConfirmEmail /> </Route>
            <Route path="/dashboard/account/change-email" exact> <DashboardAccountChangeEmail /> </Route>
            <Route path="/dashboard/account/create-password" exact> <DashboardAccountCreatePassword /> </Route>
            <Route path="/dashboard/account/plan" exact> <DashboardAccountPlan /> </Route>
            <Route path="/dashboard/account/change-plan" exact> <DashboardAccountChangePlan /> </Route>
            <Route path="/dashboard/account/cancel-subscription" exact> <DashboardAccountCancelSubscription /> </Route>
            <Route path="/dashboard/account/change-creditcard" exact> <DashboardAccountChangeCreditCard /> </Route>
            <Route path="/dashboard/player" exact> <DashboardPlayer /> </Route>
            <Route path="/dashboard/player/:video_id" exact> <DashboardPlayer /> </Route>
            <Route path="/dashboard/player/:video_id/:running" exact> <DashboardPlayer /> </Route>
            <Route path="/privacity-police" exact> <DashboardPrivacityPolice /> </Route>

            <Route path="*" exact> <NotFound /> </Route>
          </Switch>
          </Suspense>
        </div>
      </Router>
    );
}
